var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWalkthrough(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_788",
    "data-name": "Rectangle 788",
    width: 30,
    height: 30,
    transform: "translate(945.5 993.5)",
    fill: "none",
    stroke: "#b7b5b6",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_52",
    "data-name": "Mask Group 52",
    transform: "translate(-945.5 -993.5)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_10",
    "data-name": "Union 10",
    d: "M11135.281,21027.842a11.957,11.957,0,0,1-6.343-6.344,11.845,11.845,0,0,1,0-9.246,11.935,11.935,0,0,1,2.554-3.773,12.271,12.271,0,0,1,3.789-2.543,11.915,11.915,0,0,1,9.247,0,11.9,11.9,0,0,1,6.316,6.316,11.9,11.9,0,0,1,0,9.246,12.248,12.248,0,0,1-2.543,3.789,11.761,11.761,0,0,1-3.773,2.555,11.847,11.847,0,0,1-9.247,0Zm-2.211-17.785a9.7,9.7,0,1,0,6.818-2.812A9.31,9.31,0,0,0,11133.07,21010.057Zm5.975,13.469a1.355,1.355,0,0,1,.96-2.316,1.356,1.356,0,1,1-.96,2.316Zm-.307-3.854v-.252a4.243,4.243,0,0,1,.454-2.086,6.272,6.272,0,0,1,1.351-1.566,5.706,5.706,0,0,0,1.062-1.125,1.88,1.88,0,0,0,.337-1.07,1.507,1.507,0,0,0-.527-1.193,2.067,2.067,0,0,0-1.436-.475,2.339,2.339,0,0,0-1.372.406,2.5,2.5,0,0,0-.871,1.15l-.09.227-2.011-.754.1-.238a4.343,4.343,0,0,1,1.684-2.084,4.785,4.785,0,0,1,2.649-.75,4,4,0,0,1,2.834,1,3.47,3.47,0,0,1,1.087,2.654,3.611,3.611,0,0,1-.412,1.715,5.324,5.324,0,0,1-1.34,1.563,3.23,3.23,0,0,0-1.1,1.324,4.377,4.377,0,0,0-.18,1.3v.252Z",
    transform: "translate(-10178.999 -20008.002)",
    fill: "#182e7a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalkthrough);
export default __webpack_public_path__ + "static/media/walkthrough.16923d1abfb49eef43bcc0110c51675f.svg";
export { ForwardRef as ReactComponent };